import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Table, FormControl } from "react-bootstrap";
import MediaQuery from "react-responsive";
import { connect } from "react-redux";

import RecruiterDashboardBar from "../../../components/Recruiter/DashboardBar/DashboardBar";
import axios from "../../../services/axios-service";
import "./PoolViewAll.css";
import Button from "../../../components/UI/Button/Button";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import Icon from "../../../components/UI/Icon/Icon";
import SearchBox from "../../../components/UI/SearchBox/SearchBox";
import searchIcon from "../../../assets/images/search.svg";
import Loader from "../../../components/UI/Loader/Loader";
import Modal from "../../../components/UI/Modal/Modal";
import ToastNotification from "../../../components/UI/ToastNotification/ToastNotification";
import LoadingIcon from "../../../assets/images/image-loader2.gif";

/**
 * @desc show Added JobTitles and details-Desktop view
 * @param props
 * @return DOMElement
 */
const JobRowDesktop = props => {
  //ConsoleLog("colla JobRowDesktop",props.collaborators)
  const statusClassName =
    props.status === "active" ? "status status-active" : "status status-draft";
  return (
    <tr>
      <td className="date-added">{props.dateAdded}</td>
      <td className="bullhorn-id">{props.bullhornID}</td>
      <td className="job-title">{props.jobTitle}</td>
      <td className="client-company-name">{props.companyName}</td>
      <td className={statusClassName}>{props.status}</td>
      <td className="contact-name">{props.contactName}</td>
      <td
        className="permitted-contact"
        onClick={props.handlePermittedContactsClick}
      >
        {props.permittedContact.length}
        {/* <span>{props.permittedContact.length}
        <div className="permitted-contact-list">
          {props.permittedContact.length!==0?props.permittedContact.map((permittedContactName) => <p>{permittedContactName}</p>):<p>No contacts added</p>}
        </div>
        </span> */}
      </td>

      <td className="candidate-count">{props.candidateCount}</td>
      <td className="candidate-scoring">{props.scoring}</td>
      <td className="action">
        <div className="desktop-jobs-action">
          <Link
            to={{
              pathname: "/recruiter/pool-import/" + props.jobId,
              state: {
                jobTitle: props.jobTitle,
                jobBH: props.bullhornID,
                stepStateController: props.candidateCount,
                jobId: props.jobId,
                jobRecUserId: props.jobRecUserId,
                collaborators: props.collaborators,
                companyName: props.companyName
              }
            }}
          >
            <Button size="small" className="joblist-edit-button" />
          </Link>
          <Link
            to={{
              pathname: "/recruiter/pool/list/" + props.jobId,
              state: {
                jobTitle: props.jobTitle,
                jobBH: props.bullhornID,
                company_type: props.company_type
              }
            }}
          >
            <Button size="small" className="joblist-reports-button" />
          </Link>
        </div>
      </td>
    </tr>
  );
};
/**
 * @desc show Added JobTitles and details-Mobile view
 * @param props
 * @return DOMElement
 */
const JobRowMobile = props => {
  const statusClassName =
    props.status === "active" ? "status status-active" : "status status-draft";
  return (
    <div className="mobile-card">
      <div className="date-added">{props.dateAdded}</div>
      <div className="bullhorn-id">Bullhorn ID: {props.bullhornID}</div>
      <div className="job-title">
        {props.jobTitle}
        <span className="company-name"> | {props.companyName}</span>
      </div>
      <div className="candidate-count">
        No. of Candidates: {props.candidateCount}
      </div>

      <div className={statusClassName}>
        Status: <span>{props.status}</span>
      </div>
      <hr />
      <div className="action">
        <div
          className="permitted-count"
          onClick={props.handlePermittedContactsClick}
        >
          Permitted Contacts: {props.permittedContact.length}
          {/* <span>{props.permittedContact.length}</span> */}
        </div>
        {/* {(props.showList && props.cardIndex ===props.index) ?
          <div className="permitted-contact-list" ref={props.setWrapperRef}>
            <div className="permitted-contact-lists">
            {props.permittedContact.length!==0?props.permittedContact.map((permittedContactName) => <p>{permittedContactName}</p>):<p>No contacts added</p>}
            </div>
          </div>
        :""}  */}
        {/* <Link to={{pathname:'/recruiter/pool-import/' + props.jobId,
                state: {jobTitle:props.jobTitle, jobBH: props.bullhornID,
                  jobRecUserId:props.jobRecUserId,
                  collaborators:props.collaborators }}}> */}
        <Button
          size="small"
          className="joblist-edit-button"
          onClick={props.handleModal}
        />
        {/* </Link> */}
        <Link
          to={{
            pathname: "/recruiter/pool/list/" + props.jobId,
            state: { jobTitle: props.jobTitle, jobBH: props.bullhornID }
          }}
        >
          <Button size="small" className="joblist-reports-button" />
        </Link>
      </div>
    </div>
  );
};
const PermittedContactRowDesktop = props => {
  return (
    <tr>
      <td className="date-added">{props.permittedContact}</td>
    </tr>
  );
};
/**
 * @desc shows Job-title list and particular client details added by recruiter
 * @version 0.1.0
 * @author Jamshith,Praveen George
 */
class PoolViewAll extends Component {
  constructor() {
    super();
    this.state = {
      jobs: [],
      jobsSearchResults: [],
      searchParam: "",
      showList: false,
      cardIndex: "",
      loading: true,
      showModal: false,
      showPermittedContactsModal: false,
      resendConfirmModal: false,
      resendConfirmFailed: false,
      currentPermittedContactsList: [],
      currentJobId: "",
      resendEmail: "",
      resendName: "",
      isShowToast: "",
      toastMessage: "",
      permittedContactsModalCloseBtn: false,
      loaderIcon: false
    };
    this.handleAddCandidate = this.handleAddCandidate.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  jobSearchHandler = e => {
    const searchParam = e.target.value;
    this.setState({ searchParam: searchParam });
    const jobsList = [...this.state.jobs];
    const jobs = jobsList.filter(
      job =>
        job.job_name.toLowerCase().includes(searchParam.toLowerCase()) ||
        job.job_bh_id.toString().includes(searchParam.toLowerCase()) ||
        (job.client_firstname &&
          job.client_firstname
            .toLowerCase()
            .includes(searchParam.toLowerCase())) ||
        job.client_company.toLowerCase().includes(searchParam.toLowerCase())
    );
    this.setState({ jobsSearchResults: jobs });
  };

  componentDidMount() {
    this.getViewAllJobList();
    document.addEventListener("touchstart", this.handleClickOutside);
  }

  componentDidUpdate(nextProps) {
    if (this.props.recruiterDetails !== nextProps.recruiterDetails) {
      this.getViewAllJobList();
    }

    // if(this.props.location.pathname === nextProps.location.pathname){
    //   this.setState({ isShowToast: false});
    // }
    ConsoleLog("did update", this.props, "next", nextProps);
  }

  componentWillUnmount() {
    document.removeEventListener("touchstart", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showList: false });
    }
  };

  getViewAllJobList = () => {
    if (this.props.recruiterDetails.user_id) {
      axios
        .get(
          "/galaxy/job/list?isRecruiterList=1&userId=" +
            this.props.recruiterDetails.user_id
        )
        .then(response => {
          if (response && response.data) {
            const jobs = [...response.data];
            this.setState({
              jobs: jobs,
              jobsSearchResults: jobs,
              loading: false
            });
          }
        })
        .catch(error => {
          ConsoleLog(error);
          throw error;
        });
    }
  };

  handleAddCandidate(jobId) {
    this.props.history.push("/recruiter/pool-import/" + jobId);
  }

  ShowPermittedList = (e, index) => {
    e.preventDefault();
    this.setState({ showList: true, cardIndex: index });
  };

  handleModal = () => {
    window.scrollTo(0, 0);
    this.setState({ showModal: true });
  };

  handleModalOK = () => {
    this.setState({ showModal: false });
    this.props.history.push("/recruiter/dashboard");
  };

  handlePermittedContactsClick = (contacts, jobId) => {
    let list = [...contacts];
    this.setState({
      showPermittedContactsModal: true,
      currentPermittedContactsList: list,
      currentJobId: jobId,
      isShowToast: false
    });
  };

  resendPasswordConfirm = (email, name) => {
    this.setState({
      resendConfirmModal: true,
      resendEmail: email,
      resendName: name,
      permittedContactsModalCloseBtn: true
    });
  };

  handlePermittedContactsClose = () => {
    this.setState({ showPermittedContactsModal: false });
  };

  handleResendConfirmYes = () => {
    this.setState({ loaderIcon: true });
    axios
      .post("/galaxy/job/" + this.state.currentJobId + "/send", {
        reset: 1,
        clientEmail: this.state.resendEmail
      })
      .then(resp => {
        if (resp.data.message) {
          if (resp.data.message === "Success") {
            this.setState({
              resendConfirmModal: false,
              showPermittedContactsModal: false,
              permittedContactsModalCloseBtn: false,
              loaderIcon: false
            });

            this.setState({
              isShowToast: true,
              toastMessage:
                "Password successfully resent to " + this.state.resendName
            });

            setTimeout(() => {
              this.setState({ isShowToast: false });
            }, 2000);
          } else if (resp.data.message === "Cannot reset") {
            this.setState({
              resendConfirmFailed: true,
              resendConfirmModal: false,
              loaderIcon: false
            });
          } else {
          }
        }
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });

    //this.setState({ resendConfirmModal: false });
  };

  handleResendConfirmNo = () => {
    this.setState({
      resendConfirmModal: false,
      resendEmail: "",
      permittedContactsModalCloseBtn: false
    });
  };

  handleConfirmFailedOk = () => {
    this.setState({
      resendConfirmFailed: false,
      permittedContactsModalCloseBtn: false
    });
  };

  render() {
    const jobs = this.state.jobsSearchResults;
    return (
      <div>
        {/* Desktop View Section starts */}
        <MediaQuery query="(min-device-width: 769px)">
          <RecruiterDashboardBar
            activeLink="view-all-jobs"
            searchParam={this.state.searchParam}
            onHandleSearch={this.jobSearchHandler.bind(this)}
            isViewAllJobs={true}
          />
        </MediaQuery>
        {/* Desktop View Section Ends */}
        <div className="dashboard-nav-header-mobile">
          {/* Mobile View Section starts */}
          <MediaQuery query="(max-device-width: 769px)">
            <Link className="dashboardlogo" to="/recruiter/dashboard">
              <Icon
                icon="left-arrow"
                className="recruiter-back-icon "
                onClick={() => {
                  this.props.history.push("/recruiter/dashboard");
                }}
              />
            </Link>
          </MediaQuery>
          {/* Mobile View Section Ends */}
          {this.state.jobs.length !== 0 ? (
            <h1 className="pool-view-all-title">List of Jobs Added</h1>
          ) : (
            ""
          )}
        </div>
        {this.state.jobsSearchResults ? (
          <div className="pool-view-all">
            <MediaQuery query="(max-device-width: 769px)">
              <SearchBox
                value={this.state.searchParam}
                onChange={this.jobSearchHandler}
                icon={searchIcon}
                isBorder={false}
                iconPosition={"right"}
                iconInside={true}
                className={
                  this.state.searchParam && this.state.searchParam !== ""
                    ? "search-bar search-bar-active"
                    : "search-bar"
                }
              />
              <div className="mobile-cards">
                {jobs.map((job, index) => (
                  <JobRowMobile
                    key={index}
                    dateAdded={new Date(job.dateadded)
                      .toISOString()
                      .replace(/T.*/, "")
                      .split("-")
                      .reverse()
                      .join("/")}
                    bullhornID={job.job_bh_id}
                    jobTitle={job.job_name}
                    company_type={job.company_type}
                    status={job.status}
                    companyName={job.client_company}
                    candidateCount={job.noofcandidates}
                    permittedContact={job.permitted_contacts}
                    handleAddCandidate={this.handleAddCandidate}
                    jobId={job.job_id}
                    collaborators={job.collaborated_users}
                    showList={this.state.showList}
                    handleShowList={this.ShowPermittedList}
                    index={index}
                    cardIndex={this.state.cardIndex}
                    setWrapperRef={this.setWrapperRef}
                    handleModal={this.handleModal}
                    handlePermittedContactsClick={() =>
                      this.handlePermittedContactsClick(
                        job.permitted_contacts,
                        job.job_id
                      )
                    }
                  />
                ))}
                <Modal
                  className="rec-no-mobile-modal"
                  show={this.state.showModal}
                >
                  <p>
                    Please use a desktop to edit candidate profiles, this
                    feature is currently disabled on mobile for compliance
                    reasons for this iteration.
                  </p>
                  <div className="rec-no-mobile-button">
                    <Button
                      className="rec-no-mobile-ok"
                      onClick={this.handleModalOK}
                    >
                      OK
                    </Button>
                  </div>
                </Modal>
              </div>
            </MediaQuery>
            {this.state.loading ? (
              <Loader />
            ) : (
              <Fragment>
                {this.state.jobs.length === 0 ? (
                  <div className="no-jobs">
                    <div className="no-jobs-description">
                      <p>No jobs have been added </p>
                    </div>
                    <div className="list-jobs-prev-button">
                      <div className="stepper-previous-button">
                        <Button
                          onClick={() => this.props.history.goBack()}
                          size="small"
                          className="joblist-previous-button"
                          buttonicon="previous-icon"
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <MediaQuery query="(min-device-width: 768px)">
                    <Table striped condensed hover>
                      <thead>
                        <tr>
                          <th className="date-added">Date Added</th>
                          <th className="bullhorn-id">Bullhorn Job ID</th>
                          <th className="job-title">Job Title</th>
                          <th className="client-company-name">Company</th>
                          <th className="status">Status</th>
                          <th className="contact-name">
                            Job
                            <br /> Contact
                          </th>
                          <th className="permitted-contact">
                            Permitted Contact(s)
                          </th>
                          <th className="candidate-count">No. of Candidates</th>
                          <th className="candidate-scoring">Processed</th>
                          <th className="action">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jobs.map((job, index) => (
                          <JobRowDesktop
                            key={index}
                            company_type={job.company_type}
                            dateAdded={new Date(job.dateadded)
                              .toISOString()
                              .replace(/T.*/, "")
                              .split("-")
                              .reverse()
                              .join("/")}
                            bullhornID={job.job_bh_id}
                            jobTitle={job.job_name}
                            companyName={job.client_company}
                            status={job.status}
                            contactName={
                              // job.client_firstname || job.client_lastname
                              //   ? job.client_firstname === job.client_firstname ?
                              //     job.client_firstname :
                              //   job.client_firstname +
                              //     " " +
                              //     job.client_lastname
                              //   : "N/A"
                              job.client_firstname || job.client_lastname ?
                                job.client_firstname === job.client_lastname ?
                                job.client_firstname :
                                job.client_firstname +" " +job.client_lastname :
                                "NA"
                            }
                            permittedContact={job.permitted_contacts}
                            candidateCount={job.noofcandidates}
                            scoring={
                              job.noof_scoringdone + " of " + job.noofcandidates
                            }
                            handleAddCandidate={this.handleAddCandidate}
                            jobId={job.job_id}
                            jobRecUserId={job.recruiter_user_id}
                            collaborators={job.collaborated_users}
                            handlePermittedContactsClick={() =>
                              this.handlePermittedContactsClick(
                                job.permitted_contacts,
                                job.job_id
                              )
                            }
                          />
                        ))}
                      </tbody>
                    </Table>
                    <div className="list-jobs-prev-button">
                      <div className="stepper-previous-button">
                        <Button
                          onClick={() => this.props.history.goBack()}
                          size="small"
                          className="joblist-previous-button"
                          buttonicon="previous-icon"
                        />
                      </div>
                    </div>
                  </MediaQuery>
                )}
              </Fragment>
            )}
          </div>
        ) : (
          ""
        )}
        <Modal
          className="permitted-contacts-modal"
          show={this.state.showPermittedContactsModal}
        >
          <div className="permitted-contact-head">
            <p>Permitted Contacts</p>
          </div>
          <div
            className={
              this.state.resendConfirmModal
                ? "permitted-contact-table disable-resend"
                : this.state.resendConfirmFailed
                ? "permitted-contact-table disable-resend"
                : "permitted-contact-table"
            }
          >
            <table>
              <tbody>
                {this.state.currentPermittedContactsList.length > 0
                  ? this.state.currentPermittedContactsList.map(
                      ({ email, name }) => {
                        return (
                          <tr>
                            <td className="permitted-contact-name">{name}</td>
                            <td
                              className="permitted-contact-resend"
                              onClick={() =>
                                this.resendPasswordConfirm(email, name)
                              }
                            >
                              Resend password
                            </td>
                          </tr>
                        );
                      }
                    )
                  : "No contacts Added"}
              </tbody>
            </table>
          </div>

          <div className="permitted-contacts-button">
            <Button
              className="permitted-contacts-close"
              onClick={this.handlePermittedContactsClose}
              disabled={this.state.permittedContactsModalCloseBtn}
            >
              Close
            </Button>
          </div>
        </Modal>

        <Modal
          className="permitted-contacts-resend-confirm-modal"
          show={this.state.resendConfirmModal}
          nobackDrop={true}
        >
          <p className="resend-model-confirm-message">
            Are your sure you want to resend password to{" "}
            <span>{this.state.resendName}</span>?
          </p>
          <div className="permitted-contacts-resend-confirm-button">
            {this.state.loaderIcon ? (
              <img
                className="are-you-sure--loading"
                src={LoadingIcon}
                title="Updating..."
              />
            ) : (
              <div>
                <Button
                  className="permitted-contacts-resend-confirm-no"
                  onClick={this.handleResendConfirmNo}
                >
                  No
                </Button>
                <Button
                  className="permitted-contacts-resend-confirm-yes"
                  onClick={this.handleResendConfirmYes}
                >
                  Yes
                </Button>
              </div>
            )}
          </div>
        </Modal>

        <Modal
          className="permitted-contacts-resend-rejected-modal"
          show={this.state.resendConfirmFailed}
          nobackDrop={true}
        >
          <Icon
            className="reject-icon"
            icon="candidate-interview-blue-info-icon"
          />
          <p className="resend-model-reject-message">
            <span>{this.state.resendName}</span> has already setup the account!
            You are not able to resend password.
          </p>
          <div className="permitted-contacts-resend-confirm-button">
            <Button
              className="permitted-contacts-resend-confirm-ok"
              onClick={this.handleConfirmFailedOk}
            >
              OK
            </Button>
          </div>
        </Modal>

        <ToastNotification
          isShowToast={this.state.isShowToast}
          message={this.state.toastMessage}
          variant="success"
          onClose={this.handleCloseToastNotification}
          toastId={"tid" + new Date().getTime()}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  recruiterDetails: state.clientProfile.clientDetails
});

export default withRouter(
  connect(mapStateToProps, null)(withErrorHandler(PoolViewAll, axios))
);



// WEBPACK FOOTER //
// ./src/container/Recruiter/PoolViewAll/PoolViewAll.js